'use strict';

import * as types from './types';

export const getAssignments = (username, dates, byPassLoading = false) => ({
	type: types.GET_ASSIGNMENTS,
	meta: {
		async: true,
		endPoint: `/user/${ username }/getAssignments`,
		method: 'GET',
		params: {
			username,
			dates,
		},
		body: {
		},
		byPassLoading,
	},
});
